import React, { useState } from 'react'
import Layout from '../../components/layout';
import AddBrand from './AddBrand';
import EditBrand from './EditBrand';
import DeleteBrand from './DeleteBrand';
import { useQuery } from '@tanstack/react-query';
import useRead from '../../hooks/useRead';
import Spinner from '../../components/spinner';
import Errors from '../errors';
import { Button, Snackbar } from '@mui/material'
import MuiAlert from '@mui/material/Alert';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import useCreate from '../../hooks/useCreate';
import Pagination from '../../components/elements/Pagination/Pagination';
import { createSearchParams, useSearchParams } from 'react-router-dom';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Brands = () => {
  const [searchParams,setSearchParams] = useSearchParams()
  const initialState = {
    limit:10,
    pageNo:searchParams.get('pageNo') || 0
  }
  const [isOpenAddModal, setIsOpenAddModal] = useState(false)
  const [isOpenEditModal, setIsOpenEditModal] = useState(false)
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [brandId, setBrandId] = useState(0)
  const [isDeletedSuccess, setIsDeletedSuccess] = useState(false)
  const [editData, setEditData] = useState(null)
  const [brands, setBrand] = useState([])
  const [currentPage,setCurrentPage] = useState(parseInt(initialState.pageNo))

  const {queryData:handleGetProductList,paramsObject,setGetListParams} = useRead({
    url: 'getBrandList',
    initialData: initialState,  // Remove the extra wrapping object
  })

  const total_count = handleGetProductList?.data?.count;

  const handleAddBrand = () => {
    setIsOpenAddModal(true)
  }

  const handleEditBrand = (data) => {
    setIsOpenEditModal(true)
    setEditData({ ...data, logo_preview: data?.logo })
  }

  const handleCloseAddModal = () => {
    setIsOpenAddModal(false)
  }

  const handleCloseEditModal = () => {
    setIsOpenEditModal(false)
    setEditData(null)
  }
  
  const handleOpenDeleteModal = (id) => {
    setOpenDeleteModal(true)
    setBrandId(id)
  }
  
  const handleModalClose = () => {
    setOpenDeleteModal(false)
  }
  
  const deletedSuccess = () => {
    handleModalClose()
    setIsDeletedSuccess(true)
  }
  
  const handlePageClick = (val) => {
    window.scrollTo({
      top:0,
      behavior:'smooth'
    })
    let PageNo = {
        ...paramsObject,
        pageNo: val.selected
    }
    setCurrentPage(val.selected)
    setGetListParams(PageNo)
    setSearchParams(createSearchParams({
      pageNo:val.selected
    }))
  }

  return (
    <>
      <Layout>
        <div className='category'>
          <div className='category__head headingBorder__b'>
            <h2 className='titleHeading'>Brands</h2>
          </div>
          <div className='my-4 flex justify-end'>
            <Button onClick={handleAddBrand} variant="outlined" startIcon={<AddIcon />} className='primaryBtn-outlined'>
              Add Brand
            </Button>
          </div>
        </div>
        <div>
          {handleGetProductList?.isLoading
            ? <Spinner />
            : handleGetProductList?.status === "error"
              ? <Errors errorObject={handleGetProductList?.error} inline />
              : <div className="overflow-x-auto bg-white rounded-lg shadow overflow-y-auto relative">
                <table className="border-collapse table-auto w-full whitespace-no-wrap bg-white table-striped relative">
                  <thead>
                    <tr className="text-left">
                      <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                        Sr.no
                      </th>
                      <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs text-center">
                        Brand Image
                      </th>
                      <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                        Brand Name
                      </th>
                      <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                        Brand URL
                      </th>
                      <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs text-center">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {handleGetProductList?.data?.data.map((productData, idx) => {
                      const { brand_id, brand_name, brand_url, logo } = productData
                      return <tr key={idx}>
                        <td className="border-dashed border-t border-gray-200 userId">
                          <span className="text-gray-700 px-6 py-3 flex items-center text-sm">
                            {initialState.limit * initialState.pageNo + idx + 1}
                          </span>
                        </td>
                        <td className="border-dashed border-t border-gray-200 firstName">
                          <div className='w-20 h-20 mx-auto p-4'>
                            {logo ? (
                              <img src={logo} alt={`${brand_name}`} className='w-full h-full object-contain' />
                            ) : (
                              <div className='w-full h-full text-center bg-gray-200 flex items-center justify-center text-gray-500 text-xs font-medium rounded'>
                                No Image
                              </div>
                            )}
                          </div>
                        </td>
                        <td className="border-dashed border-t border-gray-200 firstName">
                          <span className="text-gray-700 px-6 py-3 flex items-center text-sm">
                            {brand_name}
                          </span>
                        </td>
                        <td className="border-dashed border-t border-gray-200 firstName">
                          <span className="text-gray-700 px-6 py-3 flex items-center text-sm">
                            {brand_url}
                          </span>
                        </td>
                        <td className="border-dashed border-t border-gray-200 phoneNumber">
                          <div className='flex items-center space-x-5 justify-center'>
                            <div>
                              <IconButton onClick={() => handleEditBrand(productData)}>
                                <EditIcon />
                              </IconButton>
                            </div>
                            <div onClick={() => handleOpenDeleteModal(brand_id)}>
                              <IconButton>
                                <DeleteIcon />
                              </IconButton>
                            </div>
                          </div>
                        </td>
                      </tr>
                    })}
                  </tbody>
                </table>
              </div>}
              <div className='my-7 flex justify-center items-center'>
                <Pagination
                currentPage={currentPage}
                onPageChange={handlePageClick}
                pageCount={Math.ceil(total_count/initialState.limit)}
                limit={initialState.limit}
                />
              </div>
        </div>
      </Layout>
      <AddBrand open={isOpenAddModal} onClose={handleCloseAddModal} />
      <EditBrand open={isOpenEditModal} onClose={handleCloseEditModal} editData={editData} />
      <DeleteBrand open={openDeleteModal} onClose={handleModalClose} id={brandId} onDelete={deletedSuccess} />
      <Snackbar open={isDeletedSuccess} autoHideDuration={4000} onClose={() => setIsDeletedSuccess(false)}>
        <Alert onClose={() => setIsDeletedSuccess(false)} severity="success" sx={{ width: '100%' }}>
          Brand Deleted Successfully
        </Alert>
      </Snackbar>
    </>
  )
}

export default Brands